import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, Globe, Users, TrendingUp } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { useCountUp } from '../../hooks/useCountUp';

const SocialProofBar: React.FC = () => {
  const { t } = useTranslation();
  const [ref, isVisible] = useScrollAnimation(0.3);

  const exams = useCountUp(1000, 2000, isVisible);
  const countries = useCountUp(50, 1500, isVisible);
  const students = useCountUp(10000, 2500, isVisible);
  const satisfaction = useCountUp(98, 1800, isVisible);

  const metrics = [
    { value: exams, suffix: '+', label: t('landing.socialProof.examsCreated'), icon: FileText, color: 'text-primary bg-primary-50' },
    { value: countries, suffix: '+', label: t('landing.socialProof.countries'), icon: Globe, color: 'text-secondary bg-secondary-50' },
    { value: students.toLocaleString(), suffix: '+', label: t('landing.socialProof.studentsTested'), icon: Users, color: 'text-accent bg-accent-50' },
    { value: satisfaction, suffix: '%', label: t('landing.socialProof.satisfactionRate'), icon: TrendingUp, color: 'text-primary bg-primary-50' },
  ];

  return (
    <section ref={ref} className="py-14 bg-gray-50 border-y border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((m, i) => {
            const Icon = m.icon;
            return (
              <div
                key={m.label}
                className={`text-center transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <div className={`w-12 h-12 rounded-xl ${m.color} flex items-center justify-center mx-auto mb-3`}>
                  <Icon size={22} />
                </div>
                <p className="font-heading text-3xl sm:text-4xl font-extrabold text-gray-900">
                  {m.value}{m.suffix}
                </p>
                <p className="text-sm text-gray-500 mt-1 font-medium">{m.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SocialProofBar;
